// extracted by mini-css-extract-plugin
module.exports = {"section_title_container":"section_title_section_title_container__31Jbc","post_title":"section_title_post_title__3mNI1","subtitle":"section_title_subtitle__8qLq2"};